export const EXCLUSIVE_RIBBON_BACKGROUND_COLOR = "#FF4B45";
export const EXCLUSIVE_RIBBON_TEXT_COLOR = "#FFFFFF";
export const EXCLUSIVE_RIBBON_LABEL = "VIP";

/** Optical text centers are independent of the triangle size. */
export const EXCLUSIVE_RIBBON_TEXT_CENTERS = {
  compact: 9.25,
  featured: 15.5,
} as const;

/** Along-ribbon optical offsets; compact is mathematically centered. */
export const EXCLUSIVE_RIBBON_TEXT_OFFSETS = {
  compact: { x: 0, y: 0 },
  featured: { x: -1, y: 1 },
} as const;

/** Native text has different baseline metrics from the browser's flex box. */
export const EXCLUSIVE_RIBBON_NATIVE_TEXT_OFFSETS = {
  compact: { x: 0, y: 1 },
  featured: { x: -1, y: 1 },
} as const;

export const EXCLUSIVE_RIBBON_VARIANTS = {
  compact: {
    width: 20,
    cornerSize: 28,
    fontSize: 7,
    lineHeight: 8,
    letterSpacing: 0.3,
  },
  featured: {
    width: 30,
    cornerSize: 42,
    fontSize: 11,
    lineHeight: 12,
    letterSpacing: 0.55,
  },
} as const;

export type ExclusiveRibbonVariant = keyof typeof EXCLUSIVE_RIBBON_VARIANTS;

export function getExclusiveRibbonMetrics(variant: ExclusiveRibbonVariant) {
  return EXCLUSIVE_RIBBON_VARIANTS[variant];
}

const ARTWORK_REFERENCE_SIZE = 56;

export function getExclusiveRibbonCornerSize({
  containerSize = ARTWORK_REFERENCE_SIZE,
  variant,
}: {
  containerSize?: number;
  variant: ExclusiveRibbonVariant;
}) {
  const cornerSize = EXCLUSIVE_RIBBON_VARIANTS[variant].cornerSize;

  return variant === "featured"
    ? cornerSize
    : cornerSize * (containerSize / ARTWORK_REFERENCE_SIZE);
}

export function getExclusiveRibbonTextCenter({
  containerSize = ARTWORK_REFERENCE_SIZE,
  variant,
}: {
  containerSize?: number;
  variant: ExclusiveRibbonVariant;
}) {
  const textCenter = EXCLUSIVE_RIBBON_TEXT_CENTERS[variant];

  return variant === "featured"
    ? textCenter
    : textCenter * (containerSize / ARTWORK_REFERENCE_SIZE);
}

export function getExclusiveRibbonTextOffset(variant: ExclusiveRibbonVariant) {
  return EXCLUSIVE_RIBBON_TEXT_OFFSETS[variant];
}

export function getExclusiveRibbonNativeTextOffset(
  variant: ExclusiveRibbonVariant,
) {
  return EXCLUSIVE_RIBBON_NATIVE_TEXT_OFFSETS[variant];
}
